import { render, staticRenderFns } from "./ModalActionsChallenge.vue?vue&type=template&id=fbdad764&scoped=true&"
import script from "./ModalActionsChallenge.vue?vue&type=script&lang=js&"
export * from "./ModalActionsChallenge.vue?vue&type=script&lang=js&"
import style0 from "./ModalActionsChallenge.vue?vue&type=style&index=0&id=fbdad764&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdad764",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
